import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import atob from 'atob';
import { Container, Segment, Button, Table, Popup, Label } from 'semantic-ui-react';

import { base } from '../../../config/constants';
import { AlertBox, ConfirmBox, setAlertMsg, askConfirmation } from '../../../components/Modals/index';

const getRemovableButton = (theme, themeType, fullAccess = false) => {
  if ((!theme || !themeType) && !fullAccess) {
    return '-';
  }

  return (
    <Label
      animated="fade"
      size="tiny"
      color={fullAccess ? 'red' : 'blue'}
      basic
    >
      {fullAccess ? 'ACCES TOTAL' : theme.toUpperCase()}
    </Label>
  );
};

export default class ListPreregistrations extends Component {
  static propTypes = {
    habilitations: PropTypes.object,
  }

  static defaultProps = {
    habilitations: {
      superuser: false,
      themes: {},
      citizenly: {},
      elected: {},
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      // selectedAdmin: null,
      listenersLoading: {
        superuser: !!props.habilitations.superuser,
        themes: props.habilitations.themes || {},
        citizenly: props.habilitations.citizenly || {},
        elected: props.habilitations.elected || {},
      },
      preinscriptions: [],
    };
  }

  componentDidMount() {
    if (this.props.habilitations.superuser) {
      // bind unitaire pour toutes
      base.bindToState('preinscriptions', {
        context: this,
        state: 'preinscriptions',
        asArray: true,
        then() {
          this.setState({
            listenersLoading: {
              superuser: false,
              themes: false,
              citizenly: false,
              elected: false,
            },
          });
        },
        onFailure(error) {
          // console.log('error');
          this.setState(setAlertMsg(
            null,
            'Impossible de récupérer la liste des préinscriptions',
            error.toString(),
            'error',
          ));
        },
      });
    } else {
      _.forEach(this.props.habilitations, (themes, themeType) => {
        if (_.indexOf(['themes', 'citizenly', 'elected'], themeType) > -1) {
          // console.log('bind ', themeType);
          _.forEach(themes, (truthy, key) => {
            // console.log('-----> bind to ', key);
            base.listenTo('preinscriptions', {
              context: this,
              asArray: true,
              queries: {
                orderByChild: themeType,
                equalTo: key,
              },
              then(preinscriptionsData) {
                if (preinscriptionsData.length > 0) {
                  const cleanData = _.uniqBy(_.concat(
                    this.state.preinscriptions,
                    preinscriptionsData,
                  ), preinscription => preinscription.key);
                  // console.log(cleanData);
                  this.setState({
                    preinscriptions: cleanData,
                    listenersLoading: {
                      superuser: false,
                      ...this.state.listenersLoading,
                      [themeType]: {
                        ...this.state.listenersLoading[themeType],
                        [key]: false,
                      },
                    },
                  });
                } else {
                  this.setState({
                    listenersLoading: {
                      superuser: false,
                      ...this.state.listenersLoading,
                      [themeType]: {
                        ...this.state.listenersLoading[themeType],
                        [key]: false,
                      },
                    },
                  });
                }
              },
            });
          });
        }
      });
    }
  }

  getAnyLoading = () => this.state.listenersLoading.superuser
    || _.some(this.state.listenersLoading.themes)
    || _.some(this.state.listenersLoading.citizenly)
    || _.some(this.state.listenersLoading.elected)


  getUserLabelContent = (email, key) => {
    if (!email) {
      return null;
    }
    return (
      <Popup
        trigger={
          <Button
            animated="fade"
            fluid
            size="tiny"
            onClick={
              () => this.handleCancelPreregistration(email, key)
            }
          >
            <Button.Content visible>
              {email.toUpperCase()}
            </Button.Content>
            <Button.Content hidden>
              Supprimer cette préinscription
            </Button.Content>
          </Button>
        }
      >
        <Popup.Content>{email}</Popup.Content>
      </Popup>
    );
  };

  handleCancelPreregistration = (email, key) => {
    // console.log('handleCancelPreregistration for (email, key)', email, key);
    this.setState(askConfirmation(
      'Supprimer une préinscription',
      `Vous allez annuler la préinscription de l'utilisateur suivant:<br/><br/>
       <strong>${email}</strong><br/><br/>
       Voulez-vous vraiment supprimer cette préinscription ?`,
      'destructive',
      () => {
        base.remove(`preinscriptions/${key}`).then(() => {
          if (!this.props.habilitations.superuser) {
            this.setState({
              preinscriptions: _.filter(this.state.preinscriptions, el => el.key !== key),
            });
          }
        }).catch((error) => {
          this.setState(setAlertMsg(
            error.code || null,
            'Impossible de supprimer cette préinscription',
            error.toString(),
            'error',
          ));
        });
      },
      'OUI, SUPPRIMER',
    ));
  }

  render() {
    // console.log(this.props.habilitations);
    // console.log(JSON.stringify(this.state.listenersLoading));
    return (
      <Container>
        <Segment basic loading={this.getAnyLoading()}>
          <Table
            compact
            selectable
            stackable
            celled
            // sortable
            tableData={this.state.preinscriptions}
            headerRow={
              <Table.Row>
                <Table.HeaderCell>
                  Identifiant
                </Table.HeaderCell>
                <Table.HeaderCell>Profession</Table.HeaderCell>
                <Table.HeaderCell>Commune</Table.HeaderCell>
                <Table.HeaderCell>Circonscription</Table.HeaderCell>
              </Table.Row>
            }
            footerRow={this.state.preinscriptions.length === 0 ?
              (
                <Table.Row>
                  <Table.Cell colSpan={5} textAlign="center" disabled>
                    <Segment basic padded="very">
                      Aucune préinscription en attente
                    </Segment>
                  </Table.Cell>
                </Table.Row>
              ) : null}
            renderBodyRow={data => (
              <Table.Row key={data.key}>
                <Table.Cell>
                  {this.getUserLabelContent(atob(data.key), data.key)}
                </Table.Cell>
                <Table.Cell collapsing>
                  {
                    data && (data.themes || (data.fullAccess && data.fullAccess.themes))
                      ? getRemovableButton(data.themes, 'themes', data.fullAccess && data.fullAccess.themes) : null
                  }
                </Table.Cell>
                <Table.Cell collapsing>
                  {
                    data && (data.citizenly || (data.fullAccess && data.fullAccess.citizenly))
                      ? getRemovableButton(data.citizenly, 'citizenly', data.fullAccess && data.fullAccess.citizenly)
                      : null
                  }
                </Table.Cell>
                <Table.Cell collapsing>
                  {
                    data && (data.elected || (data.fullAccess && data.fullAccess.elected))
                      ? getRemovableButton(data.elected, 'elected', data.fullAccess && data.fullAccess.elected) : null
                  }
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/Recipients/ListPreregistrations.js